import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  constructor(private conn: ConnectionService,private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  searchFunc(search : NgForm){
  	var data = search.value;
    this.conn.postUrl('home/filter', data).subscribe((res: any) => {
  		if (res.status == 1 || res.status == true) {
  			if(res.type=='hash'){
          this.route.navigate(['/tx'], { queryParams: { txid: data.searchkey } } );
        }else if(res.type=='address'){
  				this.route.navigate(['/address'], { queryParams: { address: data.searchkey } } );
        }else if(res.type=='contract-code'){
          this.route.navigate(['/contract-code'], { queryParams: { address: data.searchkey } } );
        }else if(res.type=='token'){
          this.route.navigate(['/token'], { queryParams: { name: data.searchkey } } );
        }
  		}else{
  			this.alert.error(res.msg);
  		}
  		search.resetForm();
  	});
  }
}
